/* eslint-disable */
/**
 * AUTO-GENERATED — do not edit.
 * Source: src/lib/analytics/events.catalog.json
 * Run: npm run analytics:codegen
 */

export const AnalyticsEvent = {
  auth: {
    userSignedUp: "user_signed_up",
    userSignedIn: "user_signed_in",
    mfaEnrolled: "mfa_enrolled",
  },
  onboarding: {
    companyCreated: "company_created",
  },
  organization: {
    userInvited: "user_invited",
    fileImportCompleted: "file_import_completed",
  },
  task: {
    created: "task_created",
  },
  activity: {
    created: "activity_created",
    unallocated: "activity_unallocated",
  },
  client: {
    customerCreated: "customer_created",
    siteCreated: "site_created",
  },
  standard: {
    schemeCreated: "scheme_created",
  },
  team: {
    inspectorCreated: "inspector_created",
    competencyCreated: "competency_created",
  },
  project: {
    created: "project_created",
    updated: "project_updated",
    deleted: "project_deleted",
    auditTypesAdded: "project_audit_types_added",
    leadAssigned: "project_lead_assigned",
    inspectorPreferenceUpdated: "project_inspector_preference_updated",
  },
  schedule: {
    activitiesAddedToPlanbox: "activities_added_to_planbox",
    appointmentsConfirmed: "appointments_confirmed",
    solutionApproved: "solution_approved",
    solutionsListOpened: "solutions_list_opened",
    solutionDetailsOpened: "solution_details_opened",
    activityInspectorsAllocated: "activity_inspectors_allocated",
    activityRescheduled: "activity_rescheduled",
    planWithAiStarted: "plan_with_ai_started",
    algorithmAllocationRequested: "algorithm_allocation_requested",
    algorithmAllocationCompleted: "algorithm_allocation_completed",
    appointmentCreated: "appointment_created",
    appointmentUpdated: "appointment_updated",
    appointmentsSplit: "appointments_split",
    appointmentsCombined: "appointments_combined",
  },
} as const;
